var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[(_vm.$route.meta.layout === 'topOnly')?_c('van-nav-bar',{staticClass:"bg-primary text-white",attrs:{"title":_vm.navbarTitle || _vm.$route.meta.title}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }